import { useI18n } from '@/lib/i18n';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { motion } from 'framer-motion';

import logoABS from '@/assets/clients/ABS.svg';
import logoADCR from '@/assets/clients/ADCR.svg';
import logoBMVA from '@/assets/clients/BMVA.svg';
import logoBPF from '@/assets/clients/BPF.svg';
import logoDPFA from '@/assets/clients/DPFA.svg';
import logoGuinnes from '@/assets/clients/Guinnes.svg';
import logoSM from '@/assets/clients/SM.svg';
import logoTL from '@/assets/clients/TL.svg';

const placeholders = [
  { id: 'abs', name: 'ABS', logo_url: logoABS },
  { id: 'adcr', name: 'ADCR', logo_url: logoADCR },
  { id: 'bmva', name: 'BMVA', logo_url: logoBMVA },
  { id: 'bpf', name: 'BPF', logo_url: logoBPF },
  { id: 'dpfa', name: 'DPFA', logo_url: logoDPFA },
  { id: 'guinnes', name: 'Guinness', logo_url: logoGuinnes },
  { id: 'sm', name: 'SM', logo_url: logoSM },
  { id: 'tl', name: 'TL', logo_url: logoTL },
];

const ClientMarquee = () => {
  const { t } = useI18n();

  const { data: clients } = useQuery({
    queryKey: ['clients'],
    queryFn: async () => {
      const { data } = await supabase.from('clients').select('*').order('sort_order');
      return data || [];
    },
  });

  const items = clients && clients.length > 0 ? clients : placeholders;
  const doubled = [...items, ...items];

  return (
    <section id="clients" className="py-16 md:py-24 border-y border-border/50 overflow-hidden">

      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {doubled.map((client, i) => (
            <div
              key={`${client.id}-${i}`}
              className="group mx-5 md:mx-8 flex-shrink-0 flex items-center justify-center h-24 w-60 opacity-50 hover:opacity-100 transition-all duration-300"
            >
              {client.logo_url ? (
                <img
                  src={client.logo_url}
                  alt={client.name}
                  className="max-h-full max-w-full object-contain brightness-0 invert transition-all duration-300 group-hover:[filter:brightness(0)_saturate(100%)_invert(85%)_sepia(100%)_saturate(500%)_hue-rotate(30deg)_brightness(110%)]"
                />
              ) : (
                <div className="w-full h-full rounded-lg bg-secondary flex items-center justify-center">
                  <span className="text-muted-foreground/40 font-display text-xs uppercase tracking-wider">Logo</span>
                </div>
              )}
            </div>
          ))}
        </div>
        {/* Fade edges */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
};

export default ClientMarquee;
